const Module = () => import('./HcetModule.vue');

import { HCE_ROUTES, PROGRAM_ROUTES } from '@/router/routeConstants';

const setBreadcrumbs = (to, from) => {
    let breadcrumbs = [];

    if (from.name == HCE_ROUTES.TRANSACTIONS.name && (to.name == 'newtransaction' || to.name == HCE_ROUTES.EDIT_TRANSACTION.name)) {
        breadcrumbs.push({ label: 'Health Care Entity Transactions', route: HCE_ROUTES.TRANSACTIONS.fullPath });
        breadcrumbs.push({ label: to.meta.title });
    }
    else if (from.name == PROGRAM_ROUTES.HCES.name && (to.name == 'newtransaction' || to.name == HCE_ROUTES.EDIT_TRANSACTION.name)) {
        breadcrumbs.push({ label: 'Review HCE Transactions', route: PROGRAM_ROUTES.HCES.fullPath });
        breadcrumbs.push({ label: to.meta.title });
    } else if (from.name == 'home' && (to.name == 'newtransaction' || to.name == HCE_ROUTES.EDIT_TRANSACTION.name)) {
        breadcrumbs.push({ label: to.meta.title });
    }
     else {
        breadcrumbs = to.meta.breadcrumb;
    }

    return breadcrumbs;
};

const filterPath = (to, from, next) => {
    if (to.fullPath !== to.path) {
      to.meta.breadcrumb = setBreadcrumbs(to, from);
      next({ path: to.path });
    } else {
      to.meta.breadcrumb = setBreadcrumbs(to, from);
      next();
    }
  };

const moduleRoutes = {
    path: '/hce',
    component: Module,
    children: [
        {
            path: HCE_ROUTES.EDIT_TRANSACTION.path,
            name: HCE_ROUTES.EDIT_TRANSACTION.name,
            props: true,
            meta: {
                title: 'Health Care Entity Transaction',
                requiresAuth: true,
                breadcrumb: [
                    { label: 'Health Care Entity Transactions', route: HCE_ROUTES.TRANSACTIONS.fullPath },
                    { label: 'Health Care Entity Transaction' }
                ]
            },
            component: () => import('./views/HceTransactionView.vue'),
            beforeEnter: filterPath
        },
        {
            path: HCE_ROUTES.TRANSACTIONS.path,
            name: HCE_ROUTES.TRANSACTIONS.name,
            meta: {
                title: 'Health Care Entity Transactions',
                requiresAuth: true,
                breadcrumb: [
                    { label: 'Health Care Entity Transactions' }
                ]
            },
            component: () => import('./views/HceTransactionListingView.vue'),
            beforeEnter: filterPath
        },
    ]
};

export default router => {
    router.addRoute(moduleRoutes);
};